import { useEffect } from 'react';

const useScript = url => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = url;
    script.async = true;
    script.id = "CookieDeclaration";
    // type="text/javascript"
    document.getElementById("script").appendChild(script);

    return () => {
      document.getElementById("script").removeChild(script);
    }
  }, [url]);
};

export default useScript;